import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  selectTab(event) {
    this.dispatch("selectTab", { detail: { tab: event.params.tab } })
  }
}
